import "./roaming.scss";

const selectors = {
  roaming: "[data-roaming]",
  roamingForm: "[data-roaming-form]",

  roamingCountry: "[data-roaming-country]",
  roamingCountryBe: "[data-roaming-country-be]",

  roamingMobileData: "[data-roaming-mobile-data]",

  roamingIncomingCalls: "[data-roaming-incoming-calls]",
  roamingIncomingSMS: "[data-roaming-incoming-sms]",

  roamingOutgoingCallsBe: "[data-roaming-outgoing-calls-be]",
  roamingOutgoingSMSBe: "[data-roaming-outgoing-sms-be]",

  roamingOutgoingCallsSelf: "[data-roaming-outgoing-calls-self]",
  roamingOutgoingSMSSelf: "[data-roaming-outgoing-sms-self]",

  roamingInternationalCalls: "[data-roaming-international-calls]",
  roamingInternationalSMS: "[data-roaming-international-sms]",

  active: "active",
};

const initRoaming = (container) => {
  if (!window.ROAMING_DATA) return;

  const language = window.ROAMING_DATA.language;
  const zones = window.ROAMING_DATA.zones;
  const countries = window.ROAMING_DATA.countries;

  const form = container.querySelector(selectors.roamingForm);

  const roamingCountry = container.querySelectorAll(selectors.roamingCountry);
  const roamingCountryBe = container.querySelector(selectors.roamingCountryBe);

  const roamingMobileData = container.querySelector(
    selectors.roamingMobileData
  );

  const roamingIncomingCalls = container.querySelector(
    selectors.roamingIncomingCalls
  );
  const roamingIncomingSMS = container.querySelector(
    selectors.roamingIncomingSMS
  );

  const roamingOutgoingCallsBe = container.querySelector(
    selectors.roamingOutgoingCallsBe
  );
  const roamingOutgoingSMSBe = container.querySelector(
    selectors.roamingOutgoingSMSBe
  );

  const roamingOutgoingCallsSelf = container.querySelector(
    selectors.roamingOutgoingCallsSelf
  );
  const roamingOutgoingSMSSelf = container.querySelector(
    selectors.roamingOutgoingSMSSelf
  );

  const roamingInternationalCalls = container.querySelector(
    selectors.roamingInternationalCalls
  );
  const roamingInternationalSMS = container.querySelector(
    selectors.roamingInternationalSMS
  );

  form.addEventListener("submit", (e) => {
    e.preventDefault();

    container.classList.add(selectors.active);

    const formValues = new FormData(e.target);
    const inputValue = formValues.get("country").toLowerCase();

    if (!inputValue) return container.classList.remove(selectors.active);

    const activeCountry = countries.find((country) =>
      country[language].toLowerCase().includes(inputValue)
    );

    if (!activeCountry) return;

    const activeZone = zones.find(
      (zone) => zone.name.toLowerCase() === activeCountry.zone.toLowerCase()
    );

    const belgium = countries.find(
      (country) => country.en.toLowerCase() === "belgium"
    );

    roamingCountry?.forEach(
      (country) => (country.innerText = activeCountry[language])
    );
    roamingCountryBe.innerText = belgium[language];

    roamingMobileData.innerText = activeZone.roaming_data_price_per_mb;

    roamingOutgoingCallsBe.innerText =
      activeZone.voice_roaming_out_prices_per_minute.find(
        (zone) => zone.zone.toLowerCase() === belgium.zone.toLowerCase()
      )?.price;
    roamingOutgoingSMSBe.innerText =
      activeZone.sms_roaming_out_prices_per_event.find(
        (zone) => zone.zone.toLowerCase() === belgium.zone.toLowerCase()
      )?.price;

    roamingOutgoingCallsSelf.innerText =
      activeZone.voice_roaming_out_prices_per_minute.find(
        (zone) => zone.zone.toLowerCase() === activeZone.name.toLowerCase()
      )?.price;
    roamingOutgoingSMSSelf.innerText =
      activeZone.sms_roaming_out_prices_per_event.find(
        (zone) => zone.zone.toLowerCase() === activeZone.name.toLowerCase()
      )?.price;

    roamingIncomingCalls.innerText =
      activeZone.voice_roaming_in_price_per_event;
    roamingIncomingSMS.innerText = activeZone.sms_roaming_in_price_per_event;

    roamingInternationalCalls.innerText =
      activeZone.international_voice_price_per_minute;
    roamingInternationalSMS.innerText =
      activeZone.international_sms_price_per_sms;
  });
};

document.addEventListener("DOMContentLoaded", async function () {
  const container = document.querySelectorAll(selectors.roaming);

  container?.forEach(initRoaming);
});
